import { SET_HIDE_MODAL_POST, SET_SHOW_MODAL_POST, CLEAR_VISORIAS_STATE, SET_NEW_VISORIA_POST, SET_ALL_VISORIAS_POST } from "../constans";
const initialState = {
    showModal: false,
    newPost:'',
    allPost:[]

}

function visorias(state = initialState, action) {
switch (action.type) {
    case SET_SHOW_MODAL_POST:
        return {...state, showModal: true };
    case SET_HIDE_MODAL_POST:
        return {...state, showModal: false};
    case CLEAR_VISORIAS_STATE:
        return initialState
    case SET_NEW_VISORIA_POST:
        return{...state, newPost: action.payload};
    case SET_ALL_VISORIAS_POST:
        return{...state, allPost: action.payload}

    default:
        return state;
}

}

export default visorias